import { render } from "./BirthChartHouseContent.vue?vue&type=template&id=684180c5&scoped=true"
import script from "./BirthChartHouseContent.vue?vue&type=script&lang=js"
export * from "./BirthChartHouseContent.vue?vue&type=script&lang=js"

import "./BirthChartHouseContent.vue?vue&type=style&index=0&id=684180c5&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684180c5"]])

export default __exports__